import React from 'react';
import { Hero } from '../components/Hero';
import { PainNarrative } from '../components/PainNarrative';
import { SolutionDetails } from '../components/SolutionDetails';
import { ProductBreakdown } from '../components/ProductBreakdown';
import { PricingSection } from '../components/PricingSection';
import { StickyBar } from '../components/StickyBar';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <div className="min-h-screen bg-white font-sans text-stone-900 selection:bg-rose-200 selection:text-rose-900" data-id="element-225">
      <Hero data-id="element-226" />
      <PainNarrative data-id="element-227" />
      <SolutionDetails data-id="element-228" />
      <ProductBreakdown data-id="element-229" />
      <PricingSection data-id="element-230" />
      <StickyBar data-id="element-231" />
      <Footer data-id="element-232" />
    </div>;
}